const DIRECTION_OFFSETS = {
  'down-left': { row: 1, col: -1 },
  'up-left': { row: -1, col: -1 },
  'down-right': { row: 1, col: 1 },
  'up-right': { row: -1, col: 1 },
};

export default DIRECTION_OFFSETS;
